const prefix = "LEVY_COLLECTION_TEMPLATE_";

export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";
export const EXPORT_JSON = prefix + "EXPORT_JSON";
export const EXPORT_SPREADSHEET = prefix + "EXPORT_SPREADSHEET";
export const GET_BODY_TAGS = prefix + "GET_BODY_TAGS";
export const GET_SUBJECT_TAGS = prefix + "GET_SUBJECT_TAGS";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const PREVIEW_GET = prefix + "PREVIEW_GET";
export const PREVIEW_SEND_EMAIL = prefix + "PREVIEW_SEND_EMAIL";
export const VIEW = prefix + "VIEW";
export const VIEW_REFRESH = prefix + "VIEW_REFRESH";
